// $(function () {
//   var selectedEvents = [];
//
//   $("#exportEvnts").click(function () {
//     var cal = ics();
//     var event;
//
//     for (var idx = 0, length = selectedEvents.length; idx < length; idx++) {
//       event = selectedEvents[idx];
//       cal.addEvent(event.title, event.description, "", event.start, event.end);
//     }
//
//     var icalEvents = cal.events();
//
//     console.log(icalEvents);
//   });
// });

$("#Refresh").click(function () {
  location.reload();
});

$("#export").click(function (e) {
  let scheduler = $("#scheduler").data("kendoScheduler");
  scheduler.saveAsPDF();
  scheduler.refresh();
});

window.preventEventChng = function (e) {
  if (
    e.event.Status === "Registered" ||
    e.event.Status === "Scheduled" ||
    e.event.Status === "Conflicted") {
    
    setTimeout(function () {}, 0);
    e.preventDefault();
  }

  if (e.event.Status === "Blocked") {
    setTimeout(function () {}, 0);
    $(".k-window-title").text("Block Time");
  }
};

window.error_handler = function(e) {
  let errors = $.parseJSON(e.xhr.responseText);
};

window.scheduler_save = function (e) {
  kRefresh();
};

window.scheduler_remove = function (e) {
  kRefresh();
};

window.scheduler_cancel = function (e) {
  e.preventDefault();
};

window.scheduler_moveE = function (e) {
  if (e.event.Status === "Registered" ||
      e.event.Status === "Scheduled" ||
      e.event.Status === "Conflicted") {
    setTimeout(function () {}, 0);
    e.preventDefault();
  }

  if (e.event.Status === "Blocked") {
    kRefresh();
  }
};

function kRefresh() {
  setTimeout(function () {
    $("#scheduler").data("kendoScheduler").dataSource.read();
  }, 500);
}
